import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { InputForm } from '@/components/ui/inputForm';

const InputTimeSelect = ({
  name,
  className,
  label,
  required = true,
  isDisabled = false,
  validate = () => {},
  description = '',
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.input.errors' });
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleChange = (event) => {
    let value = event.target.value;

    return value;
  };

  const defaultValidationRule = {
    validate: (value) => {
      if (value === '' && required) return t('filesRequired');
      if (validate(value)) {
        return validate(value);
      }
    },
  };

  const validationRules = defaultValidationRule;

  if (required) {
    validationRules.required = t('filesRequired');
  }

  return (
    <div className={className}>
      <FormField
        name={name}
        control={control}
        defaultValue=''
        rules={validationRules}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <InputForm
                disabled={isDisabled}
                type='time'
                {...field}
                error={errors[name]}
                onChange={(e) => field.onChange(handleChange(e))}
              />
            </FormControl>
            {description ? (
              <FormDescription className='tw-pt-2'>{description}</FormDescription>
            ) : null}

            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputTimeSelect;
